var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaugh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "laugh-17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1--Onboarding---emoji",
    transform: "translate(-579.000000, -530.000000)",
    fill: "#1DDCC0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(346.000000, 277.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(233.000000, 253.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laugh-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,-8.8817842e-16 C12.9837423,-2.22044605e-15 2.22044605e-15,12.9837423 0,29 C-2.22044605e-15,45.0162577 12.9837423,58 29,58 C45.0162577,58 58,45.0162577 58,29 C57.9823641,12.991053 45.008947,0.0176358707 29,-8.8817842e-16 Z M12,25 C12,22.2385763 14.2385763,20 17,20 C19.7614237,20 22,22.2385763 22,25 C22,25.5522847 21.5522847,26 21,26 C20.4477153,26 20,25.5522847 20,25 C20,23.3431458 18.6568542,22 17,22 C15.3431458,22 14,23.3431458 14,25 C14,25.5522847 13.5522847,26 13,26 C12.4477153,26 12,25.5522847 12,25 Z M29,49 C20.163444,49 13,41.836556 13,33 L45,33 C45,41.836556 37.836556,49 29,49 Z M45,26 C44.4477153,26 44,25.5522847 44,25 C44,23.3431458 42.6568542,22 41,22 C39.3431458,22 38,23.3431458 38,25 C38,25.5522847 37.5522847,26 37,26 C36.4477153,26 36,25.5522847 36,25 C36,22.2385763 38.2385763,20 41,20 C43.7614237,20 46,22.2385763 46,25 C46,25.5522847 45.5522847,26 45,26 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaugh);
export default __webpack_public_path__ + "static/media/laugh.3280cb17e4d7e330331f25270c63501a.svg";
export { ForwardRef as ReactComponent };